import { createAction, props } from '@ngrx/store';
import { DomainResponse } from '../models/domain-response.model';

export const loadUserDomains = createAction(
  '[User Domains] Load User Domains',
  props<{ page: number; perPage: number }>()
);

export const loadUserDomainsSuccess = createAction(
  '[User Domains] Load User Domains Success',
  props<{
    domains: DomainResponse[];
    meta: {
      currentPage: number;
      perPage: number;
      total: number;
      totalPages: number;
    };
  }>()
);

export const loadUserDomainsFailure = createAction(
  '[User Domains] Load User Domains Failure',
  props<{ error: string }>()
);

